import { http } from '../../config/axios'
 
export default function patchNotificacaoStatus(idNotificacao: string, inativo: boolean): Promise<string> {
  return http
    .patch('api/notificacao/'+idNotificacao, {inativo: inativo})
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro patch notificacao status', error)
      throw Error(error.response.data)
    })
}